module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p4"
  }, [_vm._v("To Victor J. Banis, "), _c('br'), _vm._v("front-line pioneer of gay fiction and a master storyteller, whose scope of work—with its emotional depth, imagination, and quality—is likely to remain unsurpassed for a very, very long time.")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Thank you for being such a generous mentor.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae2c032","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0